export default __webpack_public_path__ + "static/media/cafm-logo.fe942112.png";